import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
    Alpine.data('churnalismResults', () => ({
        activeGroup: 0,

        selectGroup(group) {
            this.activeGroup = group;
        },

        setMatchHighlight(matchId) {
            this.$el.querySelectorAll('.comp-match').forEach((node) => {
                node.classList.toggle('comp-highlight', matchId !== null && node.dataset.match === matchId);
            });
        },

        onMatchHover(event) {
            const match = event.target.closest('.comp-match');

            if (match) {
                this.setMatchHighlight(match.dataset.match);
            }
        },

        onMatchLeave(event) {
            const match = event.target.closest('.comp-match');

            if (match) {
                this.setMatchHighlight(null);
            }
        },
    }));
});

window.Alpine = Alpine;

window.initChurnalismResultsAlpine = (container) => {
    if (container) {
        Alpine.initTree(container);
    }
};

Alpine.start();
